// Item Type Selector Component
const ItemTypeSelector = ({ value, onChange }) => {
  return (
    <div className="flex items-center gap-4">
      <label className="text-sm font-bold">Item type:</label>
      <div className="flex items-center gap-4">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="itemType"
            value="show"
            checked={value === 'show'}
            onChange={(e) => onChange(e.target.value)}
            className="w-4 h-4"
          />
          <span className="text-sm">Show</span>
        </label>
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="radio"
            name="itemType"
            value="episode"
            checked={value === 'episode'}
            onChange={(e) => onChange(e.target.value)}
            className="w-4 h-4"
          />
          <span className="text-sm">Episode</span>
        </label>
      </div>
    </div>
  );
};

export default ItemTypeSelector;

